(function (root, factory) {
    if (typeof exports !== 'undefined') {
        factory(exports);
    }
    else {
        factory((root.syncscroll = {}));
    }
})(this, function (exports) {
    const Width = 'Width';
    const Height = 'Height';
    const Top = 'Top';
    const Left = 'Left';
    const scroll = 'scroll';
    const client = 'client';
    const EventListener = 'EventListener';
    const addEventListener = 'add' + EventListener;
    const length = 'length';
    const MathRound = Math.round;
    const names = {};
    const reset = function () {
        const elems = document.getElementsByClassName('sync' + scroll);
        let i, j, el, found, name;
        for (name in names) {
            if (Object.prototype.hasOwnProperty.call(names, name)) {
                for (i = 0; i < names[name][length]; i++) {
                    names[name][i]['remove' + EventListener](scroll, names[name][i].syn, 0);
                }
            }
        }
        for (i = 0; i < elems[length];) {
            found = j = 0;
            el = elems[i++];
            if (!(name = el.getAttribute('name'))) {
                continue;
            }
            el = el[scroll + 'er'] || el;
            for (; j < (names[name] = names[name] || [])[length];) {
                found |= names[name][j++] === el;
            }
            if (!found) {
                names[name].push(el);
            }
            el.eX = el.eY = 0;
            (function (el, name) {
                el[addEventListener](scroll, (el.syn = function () {
                    const elems = names[name];
                    let scrollX = el[scroll + Left];
                    let scrollY = el[scroll + Top];
                    const xRate = scrollX / (el[scroll + Width] - el[client + Width]);
                    const yRate = scrollY / (el[scroll + Height] - el[client + Height]);
                    const updateX = scrollX !== el.eX;
                    const updateY = scrollY !== el.eY;
                    let otherEl;
                    let i = 0;
                    el.eX = scrollX;
                    el.eY = scrollY;
                    for (; i < elems[length];) {
                        otherEl = elems[i++];
                        if (otherEl !== el) {
                            if (updateX &&
                                MathRound(otherEl[scroll + Left] -
                                    (scrollX = otherEl.eX = MathRound(xRate *
                                        (otherEl[scroll + Width] - otherEl[client + Width]))))) {
                                otherEl[scroll + Left] = scrollX;
                            }
                            if (updateY &&
                                MathRound(otherEl[scroll + Top] -
                                    (scrollY = otherEl.eY = MathRound(yRate *
                                        (otherEl[scroll + Height] - otherEl[client + Height]))))) {
                                otherEl[scroll + Top] = scrollY;
                            }
                        }
                    }
                }), 0);
            })(el, name);
        }
    };
    if (document.readyState === 'complete') {
        reset();
    }
    else {
        window[addEventListener]('load', reset, 0);
    }
    exports.reset = reset;
});
